import mapDefaultValues from 'utils/filters/mapDefaultValues';
import { getCurrentBrowse, historyListener } from '../actions-utils';
import { setDefaultValues } from '../filters';
import { setInitialStates } from '../init';
import { handleFetchData } from './data';

/**
 * Inital request for View Browse
 * Get remote filters, apply filter by url and get registers
 */
export const initialBrowseFetch = currentBrowse => (dispatch, getState) => {
	// Get current remote filters if exist
	const state = getCurrentBrowse(getState(), currentBrowse);
	const { filters } = state.schema;
	const formattedDefaultValues = mapDefaultValues(filters);

	dispatch(setInitialStates(state.schema)(currentBrowse));
	// Add History listener for refresh filters and data
	if (state.useUrlUpdates) dispatch(historyListener(currentBrowse));

	if (Object.keys(formattedDefaultValues)) {
		dispatch(setDefaultValues(formattedDefaultValues)(currentBrowse));
	}

	// Call function for fetch data
	dispatch(handleFetchData(false)(currentBrowse));
};
